import store from '@state/store'
import getSecret from '@utils/get-secret'

const host = window.location.host;
const parts = host.split(/[:.]+/);
let habeasDataDomain = getSecret('HABEAS_DOMAIN')
console.log("domain:", habeasDataDomain)
var routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/users/',
    name: 'users',
    component: () => lazyLoadView(import('@views/roles_management/users/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/groups/',
    name: 'groups',
    component: () => lazyLoadView(import('@views/roles_management/groups/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/perms/',
    name: 'perms',
    component: () => lazyLoadView(import('@views/roles_management/perms/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/invoice_control_euro',
    name: 'invoice_control',
    component: () => lazyLoadView(import('@views/roles_management/invoice_control/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/cuopon_types/',
    name: 'cuopon_types',
    component: () => lazyLoadView(import('@views/roles_management/coupon_types/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/euro_coupons/coupon_gestion/',
    name: 'cuopon_gestion',
    component: () => lazyLoadView(import('@views/euro_coupons/gestion/Index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/app-sections/',
    name: 'app-sections',
    component: () => lazyLoadView(import('@views/roles_management/app-sections/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/company-info/',
    name: 'company-info',
    component: () => lazyLoadView(import('@views/roles_management/company-info/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/reset-password/:otp/',
    name: 'reset-password',
    component: () => lazyLoadView(import('@views/resetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? {
          name: 'login', params: routeTo.params ? routeTo.params : {}
        } : { ...routeFrom })
      },
    },
  },
  {
    path: '/scheduled_tasks/periodic_task/',
    name: 'periodic_tasks',
    component: () => lazyLoadView(import('@views/scheduled_tasks/periodic_tasks/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/scheduled_tasks/task_result/',
    name: 'periodic_tasks',
    component: () => lazyLoadView(import('@views/scheduled_tasks/tasks_results/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/upload-sc/',
    name: 'upload_sc',
    component: () => lazyLoadView(import('@views/smart_car/')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/upload-shifts/',
    name: 'upload_shifts',
    component: () => lazyLoadView(import('@views/timesoft/')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  // START - EURO COUPONS ROUTES
  {
    path: '/euro_coupons/coupon/',
    name: 'euroCouponsCoupon',
    component: () =>
      lazyLoadView(import('@views/euro_coupons/coupon/Index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/euro_coupons/request_coupon/',
    name: 'euroCouponsRequestCoupon',
    component: () =>
      lazyLoadView(import('@views/euro_coupons/request_coupon/Index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/euro_coupons/thirdparty/',
    name: 'euroCouponsThirdparty',
    component: () =>
      lazyLoadView(import('@views/euro_coupons/thirdparty/Index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/euro_coupons/issue/',
    name: 'euroCouponsIssue',
    component: () =>
      lazyLoadView(import('@views/euro_coupons/issue/Index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/upload-habeas',
    name: 'upload-habeas',
    component: () => lazyLoadView(import('@views/habeas')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/habeas-data',
    name: 'habeasData',
    component: () => lazyLoadView(import('@views/habeasData')),
  },
  {
    path: '/habeas-data-survey',
    name: 'habeas_data_survey',
    component: () => lazyLoadView(import('@views/habeas_data/survey')),
  },
  {
    path: '/reports/report_management',
    name: 'reports-management',
    component: () => lazyLoadView(import('@views/reports/management')),
  },
  {
    path: '/reports/report_payless',
    name: 'reports-payless',
    component: () => lazyLoadView(import('@views/reports/payless')),
  },
  {
    path: '/reports/logs_payless',
    name: 'logs-payless',
    component: () => lazyLoadView(import('@views/reports/payless/logs')),
  },

  {
    path: '/upload-inventory',
    name: 'upload-inventory',
    component: () => lazyLoadView(import('@views/euro_inventory')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }
  // END - EURO COUPONS ROUTES
]
if (parts[0] === habeasDataDomain) {
  routes = [
    {
      path: '/',
      name: 'habeas_data_survey',
      component: () => lazyLoadView(import('@views/habeas_data/survey')),
    },
    {
      path: '/404',
      name: '404',
      component: require('@views/_404').default,
      // Allows props to be passed to the 404 page through route
      // params, such as `resource` to define what wasn't found.
      props: true,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
      path: '*',
      redirect: '404',
    }
  ]
}


export default routes;

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
